import { GeofencesCreatePage, GeofencesRoute } from './-components';
import { createFileRoute, useRouter } from '@tanstack/react-router';

function GeofencesCreateRoute() {
  const router = useRouter();

  return (
    <GeofencesRoute
      permission="journeys/geofences/create"
      redirectTo={(params) =>
        router.buildLocation({
          to: '/workspaces/$workspaceId/geofences',
          params: { workspaceId: params.workspaceId },
        }).href
      }
    >
      <GeofencesCreatePage />
    </GeofencesRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/geofences/new')({
  component: GeofencesCreateRoute,
});
